import React, { useState, useEffect } from "react";
import { HashLink as Link } from "react-router-hash-link";
import { HomeContainer } from "./styles";
import RegisterConsumer from "@/components/RegisterConsumer";
import SectionStores from "@/components/SectionStores";
import axios from "axios";
import { api } from "@/services/api";
import ModalPopupCommunication from "@/components/ModalPopupCommunication";

import "bootstrap/dist/css/bootstrap-grid.min.css";

export const Home = () => {
	const [data, setData] = useState(null);
	const [modalPopup, setModalPopup] = useState(false);
	const [modalContent] = useState({
		title: "COMUNICADO IMPORTANTE",
	});

	const handlePopupCommunication = () => {
		const days = 1;
		localStorage.setItem("popup-communication", JSON.stringify( {
				expire: Date.now() + (days * 24 * 60 * 60 * 1000),
		}));
		setModalPopup(false);
	};

	useEffect(() => {
		const popupStorage = JSON.parse(localStorage.getItem('popup-communication'));
		if(Date.now() >= popupStorage?.expire || popupStorage == null) {
			setModalPopup(true);
		} else {
			setModalPopup(false);
		}
	}, []);


	useEffect(() => {
		const CancelToken = axios.CancelToken; // instância do CancelToken
		const source = CancelToken.source(); // instância do source, onde está contido o token de cancelamento

		const loadData = () => {
			api.get("merchant/list/digital")
				.then((res) => {
					setData(res?.data?.list);
				})
				.catch((error) =>
					console.warn({ endPoin: "merchant/list/digital", error }),
				);
		};

		loadData();

		// retorna uma função com a finalidade fazer o cancelamento
		return () => {
			source.cancel();
		};
	}, []);

	return (
		<HomeContainer>
			<ModalPopupCommunication
				visible={false}
				message={modalContent}
				onClick={handlePopupCommunication}
			/>
			<section id='wellcome' className='container-fluid'>
				<div className='row justify-content-lg-center'>
					<div className='col-12 col-lg-11'>
						<div className='row align-items-center'>
							<div className='col-12 col-lg-5 header'>
								<h1 className='title m-text-center'>
									Programa <span>Fidelidade</span> GERIOOX
								</h1>

								<div className='button-group'>
									<Link
										to={`${process.env.PUBLIC_URL}/#register`}
										className='btn-primary'>
										cadastre-se
									</Link>
									{/* <Link
										to={`${process.env.PUBLIC_URL}/update-sigin/consumer`}
										className='btn-primary mt-2' style={{ fontSize: "0.875rem" }}>
										Já sou participante mas ainda não cadastrei minha senha
									</Link> */}
									<span className='text-separator'>ou</span>
									<p className='small-text'>
										Acesse a sua conta
									</p>
									<Link
										to={`${process.env.PUBLIC_URL}/login/consumer`}
										className='btn-secundary'>
										faça login
									</Link>
								</div>

								<img
									loading='lazy'
									className='img-responsive m-auto d-block d-lg-none'
									src={
										require("@/assets/img/cao-e-gato@3x_2.jpg")
											.default
									}
									alt='cao e gato'
								/>

								<h2 className='title m-text-center'>
									Proporcione uma vida duradoura e repleta de{" "}
									<span>qualidade de vida</span> para seu pet!
								</h2>
							</div>
							<div className='col-12 col-lg-7 d-none d-lg-block'>
								<img
									loading='lazy'
									className='img-responsive'
									src={
										require("@/assets/img/cao-e-gato@3x_2.jpg")
											.default
									}
									alt='cao e gato'
								/>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section className='container-fluid mb-5'>
				<div className='row justify-content-lg-center'>
					<div className='col-12 col-lg-8'>
						<p className='dekstop-spotlight'>
							Em torno de 7 anos de idade, cães e gatos já podem
							ser considerados animais idosos, variando pouco
							conforme a espécie e porte do animal.
						</p>
					</div>

					<div className='col-12 col-lg-10'>
						<div className='d-lg-flex'>
							<div className='pr-lg-2'>
								<p className='mb-lg-4'>
									Nesta fase, os problemas só são perceptíveis
									quando estão bem avançados. Medidas de
									prevenção são importantíssimas para
									proporcionar vida longa ao seu companheiro.
								</p>
								<p>
									Gerioox é primeiro e único medicamento
									geriátrico para cães e gatos. Graças a uma
									combinação de 3 componentes naturais, ele
									ajuda a deter os processos típicos do
									envelhecimento, melhorando a atitude e
									qualidade de vida do animal idoso.
								</p>
							</div>
							<div className='pl-lg-2'>
								<p>
									Para auxiliá-lo a proporcionar este cuidado
									por toda a vida de seu companheiro,{" "}
									<strong className='desktop-text-primary'>
										<Link to={`${process.env.PUBLIC_URL}/#register`} className='desktop-text-primary'>cadastre-se em nosso PROGRAMA FIDELIDADE
										GERIOOX</Link>
									</strong>{" "}
									e desfrute de descontos exclusivos na
									aquisição de Gerioox em nossos parceiros
									participantes do programa.
								</p>
								<img
									loading='lazy'
									className='img-responsive center '
									src={
										require("@/assets/img/gerioox-caixa.png")
											.default
									}
									alt='gerioox caixa'
								/>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section id='operation' className='container-scroll'>
				<h2 className='title'>
					Como <span>funciona</span>
				</h2>
				<div className='block-list'>
					<div className='block'>
						<h3 className='block__title'>1 - CADASTRO</h3>
						<p className='block__content'>
							Preencha todos os campos do formulário de cadastro.
						</p>
					</div>

					<div className='block'>
						<h3 className='block__title'>
							2 - CONFIRMAÇÃO DE CADASTRO
						</h3>
						<p className='block__content'>
							Recebimento de e-mail de confirmação e cupom de
							boas-vindas.
						</p>
					</div>

					<div className='block'>
						<h3 className='block__title'>
							3 - RECEBIMENTO DO CUPOM DE DESCONTO
						</h3>
						<p className='block__content'>
							O cupom de desconto sempre estará 
							disponível dentro do seu perfil.
						</p>
					</div>

					<div className='block'>
						<h3 className='block__title'>
							3 - LOJAS PARTICIPANTES
						</h3>
						<p className='block__content'>
							Troque seu cupom nas lojas ou e-commerce participantes e receba o desconto.
						</p>
					</div>
				</div>
				<Link to={`${process.env.PUBLIC_URL}/regulamento`} className='link'>
					Veja o regulamento
				</Link>
			</section>

			<section id='register' className='container-form'>
				<div className='container-fluid'>
					<div className='row justify-content-lg-center'>
						<div className='col-12 col-lg-8'>
							<header className='header-group'>
								<h2 className='title'>
									Formulário de <span>cadastro</span>
								</h2>
								<h3 className='subTitle'>
									Programa Fidelidade GERIOOX
								</h3>
							</header>

							<RegisterConsumer />
						</div>
					</div>
				</div>
			</section>

			<section
				id='stores-participants'
				className='container-fluid stores'>
				<div className='row justify-content-lg-center'>
					<div className='col-12 col-lg-11'>
						<h2 className='title'>
							Lojas <span>participantes</span>
						</h2>

						<SectionStores digitalStores={data} />
					</div>
				</div>
			</section>

			<section className='about'>
				<div className='content'>
					<h2>Sobre Gerioox</h2>
					<Link to={`${process.env.PUBLIC_URL}/sobre`}>Saiba mais</Link>
				</div>
			</section>
		</HomeContainer>
	);
};

export default Home;
